import { CompanyTitledPage } from '../../TitledPage';
import { selectUser, deleteUser } from "../../../http/api/UserApi";
import { SearchBox } from './component/SearchBox';
import { SubTitle } from './component/Subtitle';
import { UserTable } from './component/UserTable';
import { UserPagination } from './component/UserPagination';
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from 'react';

const UserListPage = () => {
  const [userList, setUserList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [searchCondition , setSearchCondition] = useState({
    keyword: "",
    type: null,
    customer: null,
    shop: null,
    listPage: 1,
    itemsPerPage: 10,
  })
  const navigate = useNavigate();

  useEffect(() => {
    search({
      keyword: "",
      type: null,
      customer: null,
      shop: null,
      listPage: 1,
      itemsPerPage: 10,
    });
  }, []);

  // 検索 -------------------------------------------------------------
  async function search (searchCondition) {
    try{
      const res = await selectUser({
        keyword: searchCondition.keyword,
        type: searchCondition.type,
        customer: searchCondition.customer,
        shop: searchCondition.shop,
        listPage: searchCondition.listPage,
        itemsPerPage: searchCondition.itemsPerPage,
      });
      setUserList(res.userListInfo.userList);
      setTotalCount(res.userListInfo.userCount);
    } catch {
      setUserList([]);
      setTotalCount(0);
    }
  };

  // SubTitle ---------------------------------------------------------
  const handleRegistrationClick = (e) => {
    navigate('/company/user_edit', {
      state: {
        screenMode: 1,
        userId: null
      }
    });
  };

  // SearchBox --------------------------------------------------------
  async function handleSearchClick (e) {
    setSearchCondition({...searchCondition, listPage: 1})
    search({...searchCondition, listPage: 1});
  }

  // Table ------------------------------------------------------------
  const handleEditClick = (userId) => (e) =>  {
    navigate('/company/user_edit', {
      state: {
        screenMode: 2,
        userId: userId
      }
    });
  };

  const handleDeleteClick = (userId, name) => async (e) => {
    const userConfirmed = window.confirm(`${name}さんを削除しますか？`);
    if (userConfirmed) {
      try {
        await deleteUser({ userId: userId });
        alert(`${name}さんを削除しました。`);
        window.location.reload();
      } catch {
        alert(`${name}さんを削除できませんでした。`);
      }
    }
  };

  // Paging -----------------------------------------------------------
  const changeItemsPerPage = (itemsPerPage) => {
    const newSearchCondition = {...searchCondition, listPage: 1, itemsPerPage: itemsPerPage }
    setSearchCondition(newSearchCondition)
    search (newSearchCondition);
  };

  const changePage = (newPage) => {
    const newSearchCondition = {...searchCondition, listPage: newPage}
    setSearchCondition(newSearchCondition);
    search (newSearchCondition);
  };

  return (
    <CompanyTitledPage title="ユーザー管理">
      <SearchBox
        onClickSearchButton={handleSearchClick}
        searchCondition={searchCondition}
        setSearchCondition={setSearchCondition}
      />
      <SubTitle
        totalCount={totalCount}
        onClickRegstrationButton={handleRegistrationClick}
      />
      <UserTable
        userList={userList}
        onClickEditButton={handleEditClick}
        onClickDeleteButton={handleDeleteClick}
      />

      <UserPagination
        totalCount={totalCount}
        listPage={searchCondition.listPage}
        itemsPerPage={searchCondition.itemsPerPage}
        changeItemsPerPage={changeItemsPerPage}
        changePage={changePage} 
      />
    </CompanyTitledPage>
  );
};

export default UserListPage;
